import firebase from 'firebase/compat/app';
import Economy from 'dt-common/constants/Economy';
import Config from '~/constants/Config';
import { CurrencyDispatcher } from '~/flux/dispatchers';
import mutationClaimKongPurchases from '~/graphql/payments/mutationClaimKongPurchases';
import { logError } from '~/logger';
import { PaymentsStoreMessage } from '../messages';

export default async function claimKongPurchases({
  playerId,
  emit,
}: {
  playerId: string | null;
  emit: (message: PaymentsStoreMessage, data?: unknown) => void;
}) {
  if (!playerId) throw new Error('playerId required');

  try {
    const result = await mutationClaimKongPurchases({
      playerId,
      kongAuthToken: kongregate.services.getGameAuthToken(),
      kongUserId: String(kongregate.services.getUserId()),
      platform: Config.PLATFORM,
    });

    if (result.currency1 != null) {
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency1: result.currency1,
      });
    }

    if (result.pdAmount > 0) {
      emit('KONG_PURCHASE_COMPLETE', result);

      if (process.env.DT_TIER === 'production') {
        const productID = `pd_${result.pdAmount}`;
        const item = (Economy.PREMIUM_ITEM_DICT as Record<string, { usd_cents: number }>)[productID];
        firebase.analytics().logEvent('purchase', {
          value: item.usd_cents / 100,
          currency: 'USD',
          transaction_id: `${playerId}-${productID}-${Date.now()}`,
          items: [{ item_id: productID }],
        });
      }
    }
  } catch (err) {
    logError(err, { module: 'PaymentsStore', func: 'claimKongPurchases' });
  }
}
